import { Fragment, useEffect, useState } from "react";
import {
  IconButton,
  Menu,
  Box,
  ListItem,
  ListItemIcon,
  ListItemText,
  List,
  CircularProgress,
  CardHeader,
  Badge,
} from "@mui/material";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { useQuery } from "react-query";
import { getNotification } from "../services/services";
import CircleNotificationsIcon from "@mui/icons-material/CircleNotifications";
import PriorityHighIcon from "@mui/icons-material/PriorityHigh";
import PrivacyTipIcon from '@mui/icons-material/PrivacyTip';
import NotificationsNoneIcon from "@mui/icons-material/NotificationsNone";
import { setItem } from "../utilis/methods/storage/storage";
function Notification() {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const [value, setValue] = useState("1");
  const [notificationCount, setNotificationCount] = useState<{
    previous: number;
    current: number;
  }>({
    previous: 0,
    current: 0,
  });
  const { data, isLoading } = useQuery(
    ["getNotificationQuery"],
    getNotification,
    {
      onSuccess: (result) => {
        setNotificationCount((prev) => ({
          ...prev,
          current:
            (result?.response?.procedures?.length || 0) +
            (result?.response?.verifications?.length || 0),
        }));
      },
      refetchOnWindowFocus: false,
      refetchInterval: 35000,
    }
  );

  const handleChange = (_: React.SyntheticEvent, newValue: string) => {
    setValue(newValue);
  };

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setNotificationCount((prev) => ({
      ...prev,
      previous: prev.current,
    }));
    setItem("previous", notificationCount.current);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  useEffect(() => {
    setNotificationCount((prev) => ({
      ...prev,
      previous: Number(localStorage.getItem("previous") || "0"),
    }));
  }, []);

  return (
    <>
      <IconButton 
      className={notificationCount.current > notificationCount.previous ? "vibrate" : ""} 
      // className={"vibrate"} 
      onClick={handleClick}>
        <Badge
          overlap="circular"
          badgeContent={
            notificationCount.current > notificationCount.previous
              ? notificationCount.current - notificationCount.previous
              : 0
          }
          color="error"
        >
          <NotificationsNoneIcon
            sx={(theme) => ({
              fontSize: "2rem",
              color: theme.palette.error.main,
            })}
          />
        </Badge>
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        // onClick={handleClose}
        slotProps={{
          paper: {
            elevation: 0,
            sx: {
              paddingTop: 0,
              overflow: "visible",
              filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              "& .MuiAvatar-root": {
                width: 32,
                height: 32,
              },
              "&::before": {
                content: '""',
                display: "block",
                position: "absolute",
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: "background.paper",
                transform: "translateY(-50%) rotate(45deg)",
                zIndex: 0,
              },
            },
          },
        }}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <div>
          <CardHeader
            sx={{ p: 1, m: 0 }}
            titleTypographyProps={{
              fontSize: "1rem",
              fontWeight: 600,
              textAlign: "center",
              color: "primary",
            }}
            title="Notifications"
          />
          <TabContext value={value}>
            <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
              <TabList
                variant="fullWidth"
                onChange={handleChange}
                aria-label="lab API tabs example"
              >
                <Tab label="Verification" value="1" />
                <Tab label="Procedure" value="2" />
              </TabList>
            </Box>
            <div className="w-[27vw] min-h-[60dvh] max-h-[60dvh] overflow-y-auto">
              <TabPanel value="1">
                <List disablePadding>
                  {data?.response?.verifications?.map((message, index) => (
                    <Fragment key={`notificationList2${index}`}>
                      <ListItem disablePadding>
                        <ListItemIcon>
                          <PrivacyTipIcon color="success" />
                        </ListItemIcon>
                        <ListItemText secondary={message} />
                      </ListItem>
                      <div className="h-2"></div>
                    </Fragment>
                  ))}
                  {isLoading && (
                    <ListItem disablePadding>
                      <ListItemIcon>
                        <CircularProgress size={20} />
                      </ListItemIcon>
                      <ListItemText primary={"Loading"} />
                    </ListItem>
                  )}
                  {!Boolean(data?.response?.verifications?.length) && (!isLoading) && (
                    <ListItem disablePadding>
                      <ListItemIcon>
                        <PriorityHighIcon color="warning" />
                      </ListItemIcon>
                      <ListItemText primary={"No notifications"} />
                    </ListItem>
                  )}
                </List>
              </TabPanel>
              <TabPanel value="2">
                <List disablePadding>
                  {data?.response?.procedures?.map((message, index) => (
                    <Fragment key={`notificationList2${index}`}>
                      <ListItem disablePadding>
                        <ListItemIcon>
                          <CircleNotificationsIcon color="primary" />
                        </ListItemIcon>
                        <ListItemText secondary={message} />
                      </ListItem>
                      <div className="h-2"></div>
                    </Fragment>
                  ))}
                  {isLoading && (
                    <ListItem disablePadding>
                      <ListItemIcon>
                        <CircularProgress size={20} />
                      </ListItemIcon>
                      <ListItemText primary={"Loading"} />
                    </ListItem>
                  )}
                  {!Boolean(data?.response?.procedures?.length) && (!isLoading) && (
                    <ListItem disablePadding>
                      <ListItemIcon>
                        <PriorityHighIcon color="warning" />
                      </ListItemIcon>
                      <ListItemText primary={"No notifications"} />
                    </ListItem>
                  )}
                </List>
              </TabPanel>
            </div>
          </TabContext>
        </div>
      </Menu>
    </>
  );
}

export default Notification;
